module.exports = __webpack_public_path__ + "img/bcp.29ffd850.svg";